import React from 'react';
import cn from 'classnames';
import { Button } from '@alfalab/core-components-button/esm';
import { CrossCircleMIcon } from '@alfalab/icons-glyph/CrossCircleMIcon';
import { CrossCircleSIcon } from '@alfalab/icons-glyph/CrossCircleSIcon';

var defaultColors = {"clearIcon":"input__clearIcon_1oj07"};
require('./default.css')

var styles = {"clearIcon":"input__clearIcon_q3ved","clearButton":"input__clearButton_q3ved","size-40":"input__size-40_q3ved"};
require('./index.css')

var invertedColors = {"clearIcon":"input__clearIcon_rceh1"};
require('./inverted.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var preventDefault = function (e) { return e.preventDefault(); };
var ClearButton = function (_a) {
    var colors = _a.colors, disabled = _a.disabled, onClick = _a.onClick, dataTestId = _a.dataTestId, size = _a.size;
    var IconComponent = size === 40 ? CrossCircleSIcon : CrossCircleMIcon;
    return (React.createElement(Button, { type: 'button', view: 'text', disabled: disabled, "aria-label": '\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C', className: cn(styles.clearButton, styles["size-".concat(size)]), onClick: onClick, tabIndex: -1, onMouseDown: preventDefault, dataTestId: dataTestId },
        React.createElement(IconComponent, { className: cn(styles.clearIcon, colorStyles[colors].clearIcon) })));
};

export { ClearButton };
